<template>
  <v-app>
    <navbar v-if="usuario != null"></navbar>
    <v-main style="background: #f2f2f2;padding-bottom: 300px;">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import navbar from './components/Navegacion.vue'
export default {
  name: 'App',

  data: () => ({
    //
  }),
  components:{
    navbar
  },
  computed:{
    ...mapState(['usuario'])
  }
};
</script>
